(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wishlist-drawer"] && !Shopify.designMode) return;
  try {
    const Wishlist = {
    items: JSON.parse(localStorage.getItem('wishlist_items') || '[]'),
    
    init() {
      this.updateCount();
      this.render();
      this.bindEvents();
    },

    bindEvents() {
      // Toggle Drawer
      document.querySelectorAll('[data-wishlist-trigger]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      document.getElementById('wishlist-close')?.addEventListener('click', () => this.close());
      document.getElementById('wishlist-overlay')?.addEventListener('click', () => this.close());
      document.querySelector('.wishlist-close-btn')?.addEventListener('click', () => this.close());

      // Global Add to Wishlist
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.wishlist-add-btn');
        if (btn) {
          e.preventDefault();
          const product = {
            id: btn.dataset.id,
            handle: btn.dataset.handle,
            title: btn.dataset.title,
            price: btn.dataset.price,
            image: btn.dataset.image,
            url: btn.dataset.url
          };
          this.add(product);
        }
      });
    },

    add(product) {
      if (!this.items.find(item => item.id === product.id)) {
        this.items.push(product);
        this.save();
        this.render();
        this.open();
      } else {
        this.open();
      }
    },

    remove(id) {
      this.items = this.items.filter(item => item.id != id);
      this.save();
      this.render();
    },

    save() {
      localStorage.setItem('wishlist_items', JSON.stringify(this.items));
      this.updateCount();
    },

    updateCount() {
      document.querySelectorAll('.wishlist-count').forEach(el => {
        el.innerText = this.items.length;
      });
    },

    render() {
      const container = document.getElementById('wishlist-items');
      const emptyState = document.getElementById('wishlist-empty');
      if (!container) return;

      if (this.items.length === 0) {
        container.innerHTML = '';
        emptyState?.classList.remove('hidden');
      } else {
        emptyState?.classList.add('hidden');
        container.innerHTML = this.items.map(item => `
          <div class="wishlist-item" data-id="${item.id}">
            <img src="${item.image}" alt="${item.title}">
            <div class="wishlist-item-info">
              <h4><a href="${item.url}" style="text-decoration:none; color:inherit;">${item.title}</a></h4>
              <p>${item.price}</p>
            </div>
            <button class="wishlist-remove" onclick="Wishlist.remove('${item.id}')" aria-label="Remove from wishlist">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 6L6 18M6 6L18 18" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        `).join('');
      }
    },

    open() {
      document.getElementById('wishlist-drawer')?.classList.add('active');
    },

    close() {
      document.getElementById('wishlist-drawer')?.classList.remove('active');
    }
  };

  document.addEventListener('DOMContentLoaded', () => Wishlist.init());
  window.Wishlist = Wishlist; // Expose to global for onclick
  } catch(e) { console.error(e); }
})();

})();
